import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import FalconComponentCard from "components/common/FalconComponentCard";
import React from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";

const DurationMedicalHistory = ({ setValue, watch, control }) => {
  const { viewModal, stepFormData, durationList } = useSelector(
    (state) => state.preauthorization
  );
  const { viewModal: claimView, stepFormData: claimData } = useSelector(
    (state) => state.preauthorization
  );
  const isPrescription =
    stepFormData?.prescription || claimData?.prescription || false;
  const durationRequired = !watch("duration") || !isPrescription;
  return (
    <Col xs={12} sm={12} md={5}>
      <FalconComponentCard className="custom-card">
        <FalconComponentCard.Body className="custom-body">
          <Row>
            <Col xs={12} sm={6} xl={3}>
              <BootDatePicker
                name="start_date"
                label="Start Date"
                size="sm"
                control={control}
                rules={{
                  required: isPrescription,
                  validate: (startDate) => {
                    const endDate = watch("end_date");
                    if (startDate && endDate && startDate > endDate) {
                      return "Start date must be before end date";
                    }
                    return true;
                  },
                }}
                isRequired={isPrescription}
                disabled={viewModal || claimView}
                selected={watch("start_date")}
                onChange={(newValue) => setValue("start_date", newValue)}
                placeholder="dd/mm/yyyy"
              />
            </Col>
            <Col xs={12} sm={6} xl={3}>
              <BootDatePicker
                name="end_date"
                label="End Date"
                size="sm"
                control={control}
                rules={{
                  required: isPrescription,
                  validate: (endDate) => {
                    const startDate = watch("start_date");
                    if (startDate && endDate && startDate > endDate) {
                      return "End date must be after start date";
                    }
                    return true;
                  },
                }}
                isRequired={isPrescription}
                disabled={viewModal || claimView}
                selected={watch("end_date")}
                onChange={(newValue) => setValue("end_date", newValue)}
                placeholder="dd/mm/yyyy"
              />
            </Col>
            <Col xs={12} sm={12} xl={6}>
              <Form.Group>
                <Form.Label>
                  Duration{" "}
                  {(watch("durationType") || isPrescription) && (
                    <span className="text-danger">*</span>
                  )}
                </Form.Label>
                <InputGroup>
                  <Controller
                    name="duration"
                    control={control}
                    disabled={viewModal || claimView}
                    rules={{
                      required: watch("durationType") || isPrescription,
                    }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        type="number"
                        min={0}
                        size="sm"
                        placeholder="Duration"
                      />
                    )}
                  />
                  <Controller
                    name="durationType"
                    control={control}
                    disabled={viewModal || claimView}
                    rules={{
                      required: !durationRequired,
                    }}
                    render={({ field }) => (
                      <Form.Select {...field} className="form-select" size="sm">
                        <option value="">Select</option>
                        {durationList.map((opt) => (
                          <option
                            key={opt.ucumtype_code}
                            value={opt.ucumtype_code}
                          >
                            {opt.ucumtype_name}
                          </option>
                        ))}
                      </Form.Select>
                    )}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>
        </FalconComponentCard.Body>
      </FalconComponentCard>
    </Col>
  );
};

export default DurationMedicalHistory;
